import { render, staticRenderFns } from "./Finale.vue?vue&type=template&id=11fb7440&scoped=true&"
import script from "./Finale.vue?vue&type=script&lang=js&"
export * from "./Finale.vue?vue&type=script&lang=js&"
import style0 from "./Finale.vue?vue&type=style&index=0&id=11fb7440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fb7440",
  null
  
)

export default component.exports